import { combineReducers } from 'redux';

import { offersFromHistoryReducer } from './offersFromHistory';
import { offersFromRecommendedApiReducer } from './offersFromRecommendedApi';

export const recommendedOffersReducer = combineReducers({
  offersFromHistory: offersFromHistoryReducer,
  offersFromRecommendedApi: offersFromRecommendedApiReducer,
});
